import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { Camera } from '@isyc-react/media/modules/camera';
import React from 'react';
import { blobToFile, dataUrlToFile } from '@isyc-react/archives/utils';
import { ViewArchive } from '@isyc-react/archives/view/view-archive.component';
import { InputDecorators, RippleButton } from '@isyc-react/form/modules/base';
import { FormSize } from '@isyc-react/form/view-model';
import mime from 'mime';
import { DropCameraType } from "./drop-camera.vm";
import { defaultPhotoExt, defaultPhotoMimeType, defaultRecordExt, defaultRecordMimeType } from "./drop-camera.vm";
import { useTranslation } from 'react-i18next';
import { nsformfile } from "../../../i18n/namespaces";
import { ViewerControlButton, ArchiveModal, ArchiveModalBody, ArchiveModalHeader, ArchiveModalCloseButton } from '@isyc-react/archives/view/viewer';
import '@isyc-react/design/main';
import "./drop-camera.style.scss";
import { ArchiveViewerProvider, ArchiveViewerView, useArchiveViewerContext } from '@isyc-react/archives/view/viewer/context';
import { getArchiveIcon } from '@isyc-react/archives/view/tools';
import clsx from 'clsx';
const ArchiveConfirmationHeader = props => {
  const {
    onBack,
    onClose,
    onNameChange,
    namePlaceholder,
    nameValue,
    nameExt
  } = props;
  const {
    setArchiveViewerData
  } = useArchiveViewerContext();
  const portal = React.useRef(null);
  const classes = React.useMemo(() => getArchiveIcon(nameExt), [nameExt]);
  React.useEffect(() => {
    const container = portal.current;
    if (container) setArchiveViewerData(data => _objectSpread(_objectSpread({}, data), {}, {
      controlsPortal: container
    }));
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center justify-content-between w-100 h-100"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center justify-content-start h-100"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center ms-0 me-2 h-100"
  }, /*#__PURE__*/React.createElement(ViewerControlButton, {
    onClick: onBack,
    className: "ms-0 me-2"
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-arrow-collapse-left"
  })), /*#__PURE__*/React.createElement("i", {
    className: clsx(classes.icon, 'font-size-26 me-2')
  }), /*#__PURE__*/React.createElement("div", {
    className: "drop-camera-photo-name-container "
  }, /*#__PURE__*/React.createElement(InputDecorators, {
    size: FormSize.MD,
    input: {
      placeholder: namePlaceholder
    },
    prefix: /*#__PURE__*/React.createElement("i", {
      className: "mdi mdi-pencil text-primary mx-2"
    }),
    suffix: /*#__PURE__*/React.createElement("div", {
      className: "extension-tag ms-2"
    }, ".", nameExt),
    focusInputOnDecoratorsFocus: true,
    value: nameValue,
    onChange: onNameChange
  })))), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center justify-content-end flex-grow-1 h-100"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center justify-content-end flex-grow-1 h-100"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-100 w-100",
    ref: portal
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center justify-content-end h-100"
  }, /*#__PURE__*/React.createElement(ArchiveModalCloseButton, {
    onClick: onClose
  }))));
};
export const DropCamera = props => {
  const {
    onFile,
    onChange,
    show,
    options
  } = props;
  const {
    t
  } = useTranslation(nsformfile.common);
  const [confirmation, setConfirmation] = React.useState(false);
  const [dataUrl, setDataUrl] = React.useState(null);
  const [blob, setBlob] = React.useState(null);
  const [name, setName] = React.useState('');
  const [ext, setExt] = React.useState('');
  React.useEffect(() => {
    if (show) {
      setConfirmation(false);
      setName('');
    }
  }, [show]);
  return /*#__PURE__*/React.createElement(ArchiveViewerProvider, {
    view: ArchiveViewerView.MODAL
  }, /*#__PURE__*/React.createElement(ArchiveModal, {
    show: show
  }, /*#__PURE__*/React.createElement(ArchiveModalHeader, null, !confirmation ? /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center justify-content-between w-100 h-100"
  }, /*#__PURE__*/React.createElement(ViewerControlButton, {
    onClick: () => onChange && onChange(false),
    className: "ms-0 me-4"
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-arrow-collapse-left"
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center"
  }, options.photo.allow && /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-camera text-primary font-size-22 me-2"
  }), options.record.allow && /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-video text-primary font-size-22 me-2"
  }), /*#__PURE__*/React.createElement("h3", {
    className: "mb-0 text-primary"
  }, options.record.allow && options.photo.allow ? /*#__PURE__*/React.createElement(React.Fragment, null, t('drop.camera.title.photoOrRecord')) : /*#__PURE__*/React.createElement(React.Fragment, null, options.record.allow ? /*#__PURE__*/React.createElement(React.Fragment, null, t('drop.camera.title.record')) : /*#__PURE__*/React.createElement(React.Fragment, null, t('drop.camera.title.photo'))))), /*#__PURE__*/React.createElement(ArchiveModalCloseButton, {
    onClick: () => onChange && onChange(false)
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ArchiveConfirmationHeader, {
    onBack: () => setConfirmation(false),
    onClose: () => onChange && onChange(false),
    namePlaceholder: dataUrl ? t('drop.camera.input.photo.name') : t('drop.camera.input.record.name'),
    nameExt: ext,
    nameValue: name,
    onNameChange: setName
  }))), /*#__PURE__*/React.createElement(ArchiveModalBody, null, !confirmation ? /*#__PURE__*/React.createElement("div", {
    className: "drop-camera-stream-container mt-2"
  }, /*#__PURE__*/React.createElement(Camera, {
    native: true,
    audio: options.record.audio,
    record: {
      allow: options.record.allow,
      options: options.record.options,
      onRecord: record => {
        if (record !== blob) {
          var _mime$getExtension, _options$record$optio, _options$record$optio2;
          setBlob(record);
          setDataUrl(null);
          setExt((_mime$getExtension = mime.getExtension((_options$record$optio = (_options$record$optio2 = options.record.options) === null || _options$record$optio2 === void 0 ? void 0 : _options$record$optio2.mimeType) !== null && _options$record$optio !== void 0 ? _options$record$optio : defaultRecordMimeType)) !== null && _mime$getExtension !== void 0 ? _mime$getExtension : defaultRecordExt);
          setConfirmation(true);
        }
      }
    },
    photo: {
      allow: options.photo.allow,
      options: options.photo.options,
      onPhoto: photo => {
        if (photo !== dataUrl) {
          var _mime$getExtension2, _options$photo$option, _options$photo$option2;
          setDataUrl(photo);
          setBlob(null);
          setExt((_mime$getExtension2 = mime.getExtension((_options$photo$option = (_options$photo$option2 = options.photo.options) === null || _options$photo$option2 === void 0 ? void 0 : _options$photo$option2.screenshotFormat) !== null && _options$photo$option !== void 0 ? _options$photo$option : defaultPhotoMimeType)) !== null && _mime$getExtension2 !== void 0 ? _mime$getExtension2 : defaultPhotoExt);
          setConfirmation(true);
        }
      }
    },
    config: {
      allow: true,
      audioInput: true,
      videoInput: true
    },
    viewportOffset: viewport => {
      const padding = 39 * 2;
      const header = 59;
      return {
        height: viewport.height - header - padding,
        width: viewport.width - padding
      };
    }
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, dataUrl && /*#__PURE__*/React.createElement(ViewArchive, {
    archive: {
      dataUrl
    }
  }), blob && /*#__PURE__*/React.createElement(ViewArchive, {
    archive: {
      blob
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "drop-camera-confirmation-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "confirmation-inner"
  }, /*#__PURE__*/React.createElement(RippleButton, {
    className: "btn btn-danger confirmation-button danger",
    rippleClassName: "ripple-danger",
    onClick: () => {
      setConfirmation(false);
    }
  }, t('drop.camera.input.cancel')), /*#__PURE__*/React.createElement(RippleButton, {
    className: "btn btn-success confirmation-button success",
    rippleClassName: "ripple-success",
    onClick: () => {
      if (onFile && ext) {
        if (dataUrl) {
          const filename = `${name || `${options.name(DropCameraType.PHOTO)}`}.${ext}`;
          const photo = dataUrlToFile(dataUrl, filename);
          onFile(photo);
        } else if (blob) {
          const filename = `${name || `${options.name(DropCameraType.RECORD)}`}.${ext}`;
          const record = blobToFile(blob, filename);
          onFile(record);
        }
      }
    }
  }, t('drop.camera.input.confirm'))))))));
};